import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex);

//创建Vuex实例
const store = new Vuex.Store({
  state: {
    api: {//api链接
      common: 'https://o-test.giant.com.cn/api',//接口demo
      login_api: 'https://sso-test.giant.com.cn/xxl-sso-server/sso', //单点登录接口
      opo_api: 'https://opo-test.giant.com.cn',//o+o登录
      giant_url: 'https://u-api-test.giant.com.cn/index.php',
    },
    externalurl: {//外部链接
      // opo: 'https://opo-test.giant.com.cn',
      opo: 'https://opo-test.giant.com.cn/opo-web/#/index',
    },
    DLINE_ENVIRONMENT: 1,//true 测试环境 false 正式环境
    FROM_OPO: false,//是否来自OPO
    loginUser: {},//登录用户信息
    browser: (function(ua){
      var a = new Object();
      var b = {
        //micromessenger: /micromessenger/.test(ua),
        msie: /msie/.test(ua) && !/opera/.test(ua),
        opera: /opera/.test(ua),
        safari: /webkit/.test(ua) && !/chrome/.test(ua),
        firefox: /firefox/.test(ua),
        edge: /edge/.test(ua),
        trident: /trident/.test(ua),
        chrome: /chrome/.test(ua)
      };
      var vMark = "";
      for (var i in b) {
        if (b[i]) { vMark = i; break; }//"safari" == i ? "version" : i;
      }
      b.version = vMark && RegExp("(?:" + vMark + ")[\\/: ]([\\d.]+)").test(ua) ? RegExp.$1 : "0";
      b.ie = b.msie;
      b.ie6 = b.msie && parseInt(b.version, 10) == 6;
      b.ie7 = b.msie && parseInt(b.version, 10) == 7;
      b.ie8 = b.msie && parseInt(b.version, 10) == 8;

      //if(vMark == "trident") vMark = "ie11";

      a.b=vMark;
      a.v=b.version;
      a.m=/mobile/i.test(ua);
      a.wx=/MicroMessenger/i.test(ua);
      a.wxminiprogram=/miniProgram/i.test(ua);
      a.giantapp=/giantapp/i.test(ua);
      a.giantopoapp = /giantopoapp/i.test(ua);
      // 云pos app
      a.giantcloudposapp = /giant_cloud_pos_app/i.test(ua) 
      // 云POS 门店app
      a.storeposapp = /giant_cloud_pos_app/i.test(ua) && /i9000s/i.test(ua)
      // 云POS 仓库app
      a.warehouseposapp = /giant_cloud_pos_app/i.test(ua) && (/autoid q9|rt40s|cruise2/i.test(ua))
      a.ios=/\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);
      a.mob= /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(ua);
      return a;
    })(window.navigator.userAgent.toLowerCase()),


    //cartCount: 0,//购物车内商品数量
    backToPrevpage: function(){//返回上一页
      router.go(-1);
    },




  },
  getters: {//相当于计算属性

  },
  mutations: {//逻辑处理，同步
    updateState( state, data ){//通用修改值
      state[data.label] = data.data;
    },
    changeApi( state, n ){//改变api链接
      if( n ){
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.api[key] = n[key]
          }
        }
      }
    },
    changeExternalurl( state, n ){//改变外部链接
      if( n ){
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.externalurl[key] = n[key]
          }
        }
      }
    },
    changeEnvironment( state ){//正式环境撤掉“测试”标志
      state.DLINE_ENVIRONMENT = false;
    },
    // changeCartCount( state, n ) {//修改购物车内商品数量
    //   state.cartCount = n;
    // },
    updateLoginUser( state, data ){//修改登录用户数据
      state.loginUser = data;
    },
  },
  actions: {//类似 mothods，异步

  }
});

//正式环境
if( window.location.host == 'o.giant.com.cn' ){
  store.commit('changeApi', {
    common: 'https://o.giant.com.cn/api',
    login_api: 'https://sso.giant.com.cn/xxl-sso-server/sso',
    opo_api: 'https://opo.giant.com.cn',//o+o登录
    giant_url: 'https://u-api.giant.com.cn/index.php',
  });
  store.commit('changeExternalurl', {
    opo: 'https://opo.giant.com.cn/opo-web/#/index',
  });
  // store.commit('changeEnvironment');
  store.commit('updateState', {
    label: 'DLINE_ENVIRONMENT',
    data: 2,
  });
}else if( window.location.host == 'o-yu.giant.com.cn' ){
  store.commit('changeApi', {
    common: 'https://o-yu.giant.com.cn/api',
    login_api: 'https://sso.giant.com.cn/xxl-sso-server/sso',
    opo_api: 'https://opo-yu.giant.com.cn',//o+o登录
    giant_url: 'https://u-api.giant.com.cn/index.php',
  });
  store.commit('changeExternalurl', {
    opo: 'https://opo-yu.giant.com.cn/opo-web/#/index',
  });
  store.commit('updateState', {
    label: 'DLINE_ENVIRONMENT',
    data: 3,
  });
}

//判断是否来自OPO
(function(){

  var tmp_domain = '';//出现条件，请填写来源域名
  if( store.state.DLINE_ENVIRONMENT == 1 ){
    tmp_domain = "opo-test.giant.com.cn";
  }else if(store.state.DLINE_ENVIRONMENT == 2){
    tmp_domain = "opo.giant.com.cn";
  }else{
    tmp_domain = "opo-yu.giant.com.cn";
  }
  var tmp_path = "";//出现条件，请填写域名后第一级目录，不判断请留空
  var refurl = "";

  if (document.referrer.length > 0) {
    refurl = document.referrer;
  } else {
    try {
      if (opener.location.href.length > 0) {
        refurl = opener.location.href;
      }
    }catch (e){}
  }
  if( window.sessionStorage ) {//localStorage
    if( sessionStorage.getItem("btn_floatbtn_backtofaxian") ) {
      refurl = sessionStorage.getItem("btn_floatbtn_backtofaxian");
    }
  }
  var refurl_domain = refurl.split("/");
  if( typeof refurl_domain[2] == "string" && refurl_domain[2].toLowerCase() == tmp_domain.toLowerCase() ) {
    if( tmp_path && typeof refurl_domain[3] == "string" ){
      if( refurl_domain[3].toLowerCase() != tmp_path.toLowerCase() ){
        return false;
      }
    }

    //如果来源页是同站，则忽略
    var thispage_url = location.href.split("/");
    if( typeof refurl_domain[2] == "string" && refurl_domain[2].toLowerCase() == thispage_url[2].toLowerCase() ){
      if( tmp_path ){
        if( typeof thispage_url[3] == "string" && refurl_domain[3].toLowerCase() == thispage_url[3].toLowerCase() ){
          return false;
        }
      } else {
        return false;
      }
    }

    if( window.sessionStorage ) {//localStorage
      sessionStorage.setItem("btn_floatbtn_backtofaxian", refurl);
    }
    console.log(store.state.FROM_OPO);
    store.commit('updateState', {
      label: 'FROM_OPO',
      data: refurl,
    });
    console.log(store.state.FROM_OPO);

  }
})();



//导出store
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js